export const MainWorkList = [
  {
    id: 1,
    url: "CoranoJewelry",
    title: "Corano Jewelry",
    src: require("./assets/images/Corano.png"),
    content:
      "A personal jewelry brand landing page built with HTML, CSS, and vanilla JavaScript, featuring smooth animations and responsive design.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 2,
    url: "Kyyeudreamers",
    title: "Kyyeudreamers",
    src: require("./assets/images/Kyyeudreammer.png"),
    content:
      "A showcase website for a yearbook photography studio, built with Next.js, Tailwind CSS, SCSS, Ant Design, MongoDB, and Firebase.",
    techStack: ["Next.js", "Tailwind CSS", "SCSS", "Ant Design", "MongoDB", "Firebase"],
  },
  {
    id: 3,
    url: "IronFitness",
    title: "Iron Fitness",
    src: require("./assets/images/IronFitness.png"),
    content:
      "A fitness brand landing page built with HTML, CSS, and vanilla JavaScript, focused on clean layout and responsive design.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 4,
    url: "SocialApp",
    title: "Social App",
    src: require("./assets/images/SocialApp.png"),
    content:
      "A full-stack social platform built with Next.js, TanStack Query, NextAuth.js, Tailwind CSS, SCSS, and Prisma with MongoDB.",
    techStack: ["Next.js", "TanStack Query", "NextAuth.js", "Tailwind CSS", "Prisma", "MongoDB"],
  },
];

export const WorkDetailList = [
  {
    id: 1,
    url: "CoranoJewelry",
    title: "Corano Jewelry",
    bgColor: "#c29958",
    src: [
      require("./assets/images/WorksCorano/1.png"),
      require("./assets/images/WorksCorano/2.png"),
    ],
    video: require("./assets/videos/CoranoMarket.mp4"),
    content:
      "A personal jewelry brand landing page built with HTML, CSS, and vanilla JavaScript, featuring smooth animations and a fully responsive experience across devices.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 2,
    url: "Kyyeudreamers",
    title: "Kyyeudreamers",
    bgColor: "#abffb2",
    src: [
      require("./assets/images/WorksKyyeudreamer/1.png"),
      require("./assets/images/WorksKyyeudreamer/2.png"),
      require("./assets/images/WorksKyyeudreamer/admin.png"),
    ],
    video: require("./assets/videos/Kyyeudreamer.mp4"),
    content:
      "A showcase website for Kyyeudreamers, a yearbook photography studio in Vietnam, built with Next.js for SEO, Tailwind CSS, SCSS, Ant Design, MongoDB, and Firebase.",
    techStack: [
      "Next.js",
      "Tailwind CSS",
      "SCSS",
      "Ant Design",
      "MongoDB",
      "Firebase",
    ],
  },
  {
    id: 3,
    url: "IronFitness",
    title: "Iron Fitness",
    bgColor: "#bf0a2b",
    src: [
      require("./assets/images/WorksIronFitness/1.png"),
      require("./assets/images/WorksIronFitness/2.png"),
    ],
    video: require("./assets/videos/IronFitness.mp4"),
    content:
      "A fitness brand landing page built with HTML, CSS, and vanilla JavaScript, featuring subtle animations and a responsive layout across devices.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 4,
    url: "SocialApp",
    title: "Social App",
    bgColor: "#e60112",
    src: [
      require("./assets/images/WorksSocialApp/1.png"),
      require("./assets/images/WorksSocialApp/2.png"),
      require("./assets/images/WorksSocialApp/3.png"),
    ],
    video: require("./assets/videos/SocialApp.mp4"),
    content:
      "A full-stack social platform built with Next.js, TanStack Query, NextAuth.js, Tailwind CSS, SCSS, and Prisma with MongoDB, created to strengthen end-to-end product development skills.",
    techStack: [
      "Next.js",
      "TanStack Query",
      "NextAuth.js",
      "Tailwind CSS",
      "SCSS",
      "Prisma",
      "MongoDB",
    ],
  },
];

export const WorkList = [
  {
    id: 1,
    url: "CoranoJewelry",
    title: "Corano Jewelry",
    src: require("./assets/images/Corano.png"),
    content:
      "A personal jewelry brand landing page built with HTML, CSS, and vanilla JavaScript, featuring smooth animations and a fully responsive experience across devices.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 2,
    url: "Kyyeudreamers",
    title: "Kyyeudreamers",
    src: require("./assets/images/Kyyeudreammer.png"),
    content:
      "A showcase website for Kyyeudreamers, a yearbook photography studio in Vietnam, built with Next.js for SEO, Tailwind CSS, SCSS, Ant Design, MongoDB, and Firebase.",
    techStack: [
      "Next.js",
      "Tailwind CSS",
      "SCSS",
      "Ant Design",
      "MongoDB",
      "Firebase",
    ],
  },
  {
    id: 3,
    url: "IronFitness",
    title: "Iron Fitness",
    src: require("./assets/images/IronFitness.png"),
    content:
      "A fitness brand landing page built with HTML, CSS, and vanilla JavaScript, featuring subtle animations and a responsive layout across devices.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 4,
    url: "SocialApp",
    title: "Social App",
    src: require("./assets/images/SocialApp.png"),
    content:
      "A full-stack social platform built with Next.js, TanStack Query, NextAuth.js, Tailwind CSS, SCSS, and Prisma with MongoDB, created to strengthen end-to-end product development skills.",
    techStack: [
      "Next.js",
      "TanStack Query",
      "NextAuth.js",
      "Tailwind CSS",
      "SCSS",
      "Prisma",
      "MongoDB",
    ],
  },
];

export const SkillCategories = [
  {
    category: "AI-Assisted Development",
    items: ["Cursor IDE", "Claude CLI", "Model Context Protocol (MCP)"],
  },
  {
    category: "Programming Languages",
    items: ["HTML", "CSS", "SCSS", "JavaScript (ES6+)", "TypeScript"],
  },
  {
    category: "Front-end Techstack",
    items: ["ReactJS/NextJS", "VueJS/NuxtJS"],
  },
  {
    category: "Back-end Techstack",
    items: ["NodeJS", "ExpressJS", "PostgreSQL"],
  },
  {
    category: "State Management",
    items: ["Zustand", "TanStack Query", "React Context API"],
  },
  {
    category: "Form & Validation",
    items: ["Zod", "React-Hook-Form"],
  },
  {
    category: "UI Libraries",
    items: ["Ant Design (AntD)", "Shadcn/UI", "Material UI (MUI)"],
  },
  {
    category: "Styling Frameworks",
    items: ["TailwindCSS", "SCSS", "Styled Components"],
  },
];

export const ExperienceList = [
  {
    timeline: "March 2022 - June 2026",
    position: "Software Engineer",
    company: "Nimbus Tech JSC",
  },
  {
    timeline: "March 2022 - March 2023",
    position: "Front-End Developer",
    company: "Eastplayers Cop",
  },
  {
    timeline: "July 2021 - October 2021",
    position: "Internship Front-End Developer",
    company: "JAMstack Vietnam Cop",
  },
];
